import { SidebarTrigger } from '../ui/sidebar';
import Logo from '../logo';

export function MobileTopBar() {
  return (
    <div className="md:hidden sticky top-0 z-50 backdrop-blur-xl border-b border-border/40 bg-background/80">
      <div className="h-16 px-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <SidebarTrigger className="h-10 w-10 hover:bg-muted transition-colors rounded-xl" />
          <Logo className="h-7 w-auto" />
        </div>
        <div className="h-8 w-8 rounded-full bg-gradient-to-tr from-primary/20 to-primary/5 border border-primary/10" />
      </div>
    </div>
  );
}
